import React from 'react';
import PropTypes from 'prop-types';
import { formatValue } from '../shared-utils';

const Fee = ({
  title,
  value,
  date,
  helpContent,
  handleClick,
}) => {
  /* eslint-enable no-nested-ternary */
  const valueToShow = formatValue(value, true);

  return (
    <div>
      {helpContent.length !== 0 && (
        <div className="title help" onClick={handleClick(title, helpContent)} role="button" tabIndex={-1}>
          <span className="fee-title">{title}</span>
          <span className="question-mark">?</span>
        </div>
      )}
      {helpContent.length === 0 && (
        <div className="title">
          <span className="fee-title">{title}</span>
        </div>
      )}
      <div className="fee">
        <span>{valueToShow}</span>
        <span className="small">p.a.</span>
        {date && <span className="date">{`(${date})`}</span>}
      </div>
    </div>
  );
};

Fee.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.string,
  date: PropTypes.string,
  helpContent: PropTypes.arrayOf(PropTypes.string),
  handleClick: PropTypes.func,
};

Fee.defaultProps = {
  value: '0',
  date: null,
  helpContent: [],
  handleClick: () => null,
};

export default Fee;
